import React from 'react';
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Button,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

export default function AlertWarning({ isOpen, onClose, msg, header }) {
  const { t } = useTranslation();
  const cancelRef = React.useRef();
  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader
            fontSize="lg"
            fontWeight="bold"
          >
            {header}
          </AlertDialogHeader>

          <AlertDialogBody>{msg}</AlertDialogBody>
          <AlertDialogFooter>
            <Button
              colorScheme="facebook"
              ml={3}
              ref={cancelRef}
              onClick={onClose}
            >
              {t('ACCEPT')}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
}
